<div
  class="flex cursor-pointer items-center gap-2 border-none bg-transparent text-sm text-(--content-neutral-secondary)"
  [attr.aria-label]="'SHARED.CLOCK.ARIA_LABEL' | translate"
  data-testid="btn-clock"
>
  <i class="pi pi-clock"></i>
  <span data-testid="span-clock-time">{{ time() | date: format() }}</span>
  @if (label(); as label) {
    <span class="text-xs opacity-70" data-testid="span-clock-tz">{{ label }}</span>
  }
</div>
